import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { t } from '../../utilities/translator';
import format from '../../utilities/format';
import { createPortal } from 'react-dom';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { pushEvent } from '../../utilities/analytics';
import {
  DOTD_POPUP_DISPLAYED,
  DOTD_SUBSCRIBE_CLICK
} from '../../constants/analyticEvents';
// import abTesting from '../../services/abTesting';

const DealOfTheDayModal = ({
  dealItem,
  showOfferPopup,
  closeModal,
  subscribeSuccess,
  setSubscribeSuccess,
}) => {
  const modalRef = useRef(null);
  const [modalScrolled, setModalScrolled] = useState(false);

  const userContext = JSON.parse(localStorage.getItem('hf_user'));
  const isSubscribed = !!(userContext && userContext?.userNotificationPreferences?.enabledDealOfTheDay);

  useOnClickOutside(modalRef, () => {
    if (showOfferPopup) {
      closeModal();
    }
  });

  useEffect(() => {
    if (!showOfferPopup && modalScrolled) {
      // scroll to top after modal close if it was scrolled
      setModalScrolled(false);
    }
    if (showOfferPopup) {
      pushEvent(DOTD_POPUP_DISPLAYED, { offer: dealItem });
    }
  }, [showOfferPopup]);

  useEffect(() => {
    // close modal on browser back button
    const handlePopState = () => {
      if (showOfferPopup) {
        closeModal();
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showOfferPopup, closeModal]);

  const handleSubscribe = () => {
    const userContext = JSON.parse(localStorage.getItem('hf_user'));
    const muId = userContext.user.muid;
    const userDataToSend = {
        user: {
            ...userContext.user
        },
        userNotificationPreferences: {
            ...userContext.userNotificationPreferences,
            enabledDealOfTheDay: true,
        }
    };
    setSubscribeSuccess(true);
    // console.log('Subscribe click:', userDataToSend);
    // eslint-disable-next-line no-undef
    if (typeof user !=='undefined' && typeof user.updateUserContext === 'function') {
      // eslint-disable-next-line no-undef
      user.updateUserContext(userDataToSend, muId)
        .then((data) => {
          const hfUser = JSON.parse(localStorage.getItem('hf_user'));
          console.log('context updated::', data, hfUser);
          //dispatch(setUser(hfUser));
        });
    }
    pushEvent(DOTD_SUBSCRIBE_CLICK, { offer: dealItem });
  };

  const subscribeSuccessBlock = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate()+1);
    return (
      <>
        <div className="dotd-ops-icon"></div>
        <div className="dotd-ops-main flex flex-col gap-4">
          <div className="dotd-ops-1">{t('dealOfTheDay.youreIn')}</div>
          <div className="dotd-ops-2">
            {t('dealOfTheDay.youWillBeTheFirstToReceiveTheDeal')}
          </div>
          <div className="dotd-ops-3">
            <b>{t('dealOfTheDay.startingAtDate', { date: format(tomorrow, 'd MMM') })}</b>
          </div>
          <div className="dotd-ops-4">
            {t('dealOfTheDay.youCanChangeTheseSettings')}
          </div>
        </div>
      </>
    );
  };

  const notSubscribedBlock = () => {
    return (
      <>
        <div className="dotd-opns-top flex flex-col gap-5">
          <div className="dotd-opns-title font-bold">
            {t('dealOfTheDay.everyDayNewDestination')}
          </div>
          <div className="dotd-opns-txt font-medium">
            {t('dealOfTheDay.fromMillionsOfOffers')}
          </div>
        </div>
        <div className="dotd-opns-bot flex flex-col gap-5">
          <div className="dotd-opnsb-txt font-medium flex flex-col gap-1">
            <span className="font-semibold">{t('dealOfTheDay.wannaBeTheFirst')}</span>
            <span className="text-[14px] leading-none text-shark-500">{t('dealOfTheDay.youCanCancelAnyTime')}</span>
          </div>
          <div className="dotd-opnsb-button flex">
            <button className="move-btn move-btn--primary move-btn--large rounded" onClick={handleSubscribe}>
              {t('dealOfTheDay.subscribeFor30Days')}
            </button>
          </div>
        </div>
      </>
    )
  };

  return createPortal(
    <CSSTransition
      in={showOfferPopup}
      timeout={300}
      classNames="dotd-animate"
      unmountOnExit
      mountOnEnter
    >
      <div className="dotd-offer-popup-overlay">
        <div className="dotd-offer-popup">
          <div
            className={classNames("dotd-op-main", { 'dotd-opm-subscribed': (isSubscribed && !subscribeSuccess), 'dotd-opm-notsubscribed': (!isSubscribed || subscribeSuccess) })}
            ref={modalRef}
          >
            <div className="dotd-op-head">
              <span className="dotd-op-close" onClick={closeModal}><i className="ri-close-line" /></span>
            </div>
            <div className="dotd-op-body">
              {(!isSubscribed || subscribeSuccess) &&
                <div className={classNames("dotd-op-ns flex flex-col gap-5 relative", { 'dotd-ops-success': subscribeSuccess, 'dotd-op-scrolled': modalScrolled })}>
                  <div className="dotd-ribbon absolute-fix absolute top-5 flex flex-col items-start gap-3">
                    <div className="card-ribbon card-ribbon__all-inclusive text-sm !font-semibold leading-none flex gap-2 items-center">
                      <i className="ri-trophy-line" />
                      <span>{t('dealOfTheDay.dealOfTheDay')}</span>
                    </div>
                  </div>
                  {subscribeSuccess ? subscribeSuccessBlock() : notSubscribedBlock()}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById('modal-portal')
  );
};

export default DealOfTheDayModal;
